/** 포커 게임홈에서 DOM에 설정한 환경 정보를 읽는다. */
export function parseSettings() {
  var data = $('.app__initial-state').data()

  return {
    env: data.env || 'dev',
    game: data.game || '7poker',
    gameName: data.gameName || '7포커',
    ssn: data.ssn || 156,
  }
}
